import React from 'react';
import { EditOutlined } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';
import { IconButton } from 'components/Elements/Buttons/IconButton';
import { formatMaskedEmail } from 'utils/formatMaskedEmail';

export interface MaskedEmailFieldProps {
  maskedEmail?: string | null;
  name: string;
  onEdit: () => void;
  align?: 'left' | 'right';
}

export const MaskedEmailField: React.FC<MaskedEmailFieldProps> = ({ maskedEmail, name, onEdit, align = 'left' }) => {
  const displayEmail = formatMaskedEmail(maskedEmail);
  const [tooltipOpen, setTooltipOpen] = React.useState(false);

  const editButton = (
    <Tooltip
      title="Edit email address"
      arrow
      open={tooltipOpen}
      disableInteractive
      onOpen={() => setTooltipOpen(true)}
      onClose={() => setTooltipOpen(false)}
      PopperProps={{ sx: { zIndex: theme => theme.zIndex.modal - 1 } }}
    >
      <span>
        <IconButton
          size="medium"
          color="primary"
          aria-label={`Edit email for ${name}`}
          onClick={event => {
            event.stopPropagation();
            setTooltipOpen(false);
            event.currentTarget.blur();
            onEdit();
          }}
          sx={{ flexShrink: 0 }}
        >
          <EditOutlined />
        </IconButton>
      </span>
    </Tooltip>
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      minWidth={0}
      gap={0.5}
      justifyContent={align === 'right' ? 'flex-end' : 'flex-start'}
      boxSizing="border-box"
      pr={align === 'right' ? 1.8 : 0}
    >
      {align === 'right' && editButton}
      <Typography variant="body2" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', textAlign: align }}>
        {displayEmail}
      </Typography>
      {align !== 'right' && editButton}
    </Box>
  );
};
